import { Input } from "@/components/ui/input.tsx";
import { Button } from "@/components/ui/button.tsx";
import { ChevronRight, Info } from "lucide-react";
import React, { useState } from "react";
import { SlAPSHOT_BASE_URL } from "@/env";
import { gql, useMutation } from "@apollo/client";
import { TabProps } from "@/components/SettingsSidepanel/settings.types.ts";
import {
  AddSlapshotApiKeyMutation,
  AddSlapshotApiKeyMutationVariables,
} from "@/__generated__/graphql";
import SettingsSheetHeader from "@/components/SettingsSidepanel/SettingsSheetHeader.tsx";
import { Separator } from "@/components/ui/separator.tsx";
import SettingsSheetProfile from "@/components/SettingsSidepanel/SettingsSheetProfile.tsx";

const ADD_SLAPSHOT_API_KEY = gql`
  mutation AddSlapshotApiKey($apiKey: String!) {
    addOrUpdateHotrockApiKey(apiKey: $apiKey) {
      success
    }
  }
`;
const SlapshotIntegrationTab: React.FC<TabProps> = ({ onRequestClose }) => {
  const [slapshotApiKey, setSlapshotApiKey] = useState<string>("");

  const [addSlapshotApiKey] = useMutation<
    AddSlapshotApiKeyMutation,
    AddSlapshotApiKeyMutationVariables
  >(ADD_SLAPSHOT_API_KEY);

  return (
    <>
      <SettingsSheetHeader
        onRequestClose={onRequestClose}
        title="Integration"
      />

      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-4 p-4 rounded-[16px] border border-accent-foreground text-sm">
          <SettingsSheetProfile />
          <Separator />
          <div className="flex flex-row justify-between gap-3">
            <Input
              placeholder="Enter Slapshot API Key"
              className="border-none placeholder:text-base bg-accent dark:bg-accent"
              value={slapshotApiKey}
              onChange={(e) => setSlapshotApiKey(e.target.value)}
            />
            <Button
              variant="paint"
              onClick={async () => {
                await addSlapshotApiKey({
                  variables: { apiKey: slapshotApiKey },
                });
              }}
            >
              Submit
            </Button>
          </div>
          <div className="flex flex-row gap-5 bg-tertiary px-[10px] py-[14px] rounded-[8px] items-center text-primary-foreground">
            <div className="flex gap-2 items-top">
              <Info className="h-4 w-4 mt-1" />
              <p className="text-base">
                If you already have an account in Slapshot, then generate
                generate an API key by
              </p>
            </div>
            <a
              href={`${SlAPSHOT_BASE_URL}/profile`}
              target="_blank"
              className="text-sm font-medium whitespace-nowrap inline-flex items-center"
            >
              Click here
              <ChevronRight className="w-4 h-4" />
            </a>
          </div>
          <div className="flex flex-row gap-5 bg-tertiary px-[10px] py-[14px] rounded-[8px] items-center text-primary-foreground">
            <div className="flex gap-2 items-top">
              <Info className="h-4 w-4 mt-1" />
              <p className="text-base">
                If you don't have an account in Slapshot, then you can register
                by
              </p>
            </div>
            <a
              href={`${SlAPSHOT_BASE_URL}/auth/register`}
              target="_blank"
              className="text-sm font-medium items-center whitespace-nowrap inline-flex"
            >
              Register now
              <ChevronRight className="w-4 h-4" />
            </a>
          </div>
        </div>
      </div>
    </>
  );
};
export default SlapshotIntegrationTab;
